import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA6bHlmGKBvHqjAOqFpfnc0ZlciS11C4w4",
  authDomain: "tattvadynamics.firebaseapp.com",
  projectId: "tattvadynamics",
  storageBucket: "tattvadynamics.firebasestorage.app",
  messagingSenderId: "991066268990",
  appId: "1:991066268990:web:3a14bc08ae29c7bb57b86f",
  measurementId: "G-W8VPCHELME"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics }; 